import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-file-drop',
  templateUrl: './file-drop.component.html',
  styleUrls: ['./file-drop.component.scss']
})
export class FileDropComponent implements OnInit {

  @Input()
  files: File[] = [];

  @Output()
  filesChange = new EventEmitter<File[]>();

  @Input()
  multiple = false;

  @Input()
  disabled = false;

  @Output()
  onChange = new EventEmitter<File[]>();

  hasDropZoneOver        = false;
  uploader: FileUploader = new FileUploader({});

  @ViewChild('fileInput')
  fileInput: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }

  fileDropped(files: FileList) {
    if (this.disabled) {
      return;
    }

    this.changeFiles(files);
  }

  fileOver(event) {
    this.hasDropZoneOver = event;
  }

  fileSelected(event: any) {
    const element: HTMLInputElement = event.srcElement;
    this.changeFiles(element.files);
    this.fileInput.nativeElement.value = '';
  }

  changeFiles(fileList: FileList) {
    const files = [];

    if (fileList) {
      for (let i = 0; i < fileList.length; i++) {
        files.push(fileList.item(i));
      }

    }

    this.files = files;
    this.filesChange.emit(this.files);
    this.onChange.emit(this.files);
  }

  removeFile(file: File) {
    const index = this.files.indexOf(file);

    if (index !== -1) {
      this.files.splice(index, 1);
    }
  }
}
